export const PAGE_SIZE_POSTGREST = 1000;

export async function fetchAllPages<T>(
  buildQuery: (from: number, to: number) => PromiseLike<{ data: T[] | null; error: unknown }>,
): Promise<T[]> {
  const result: T[] = [];
  let from = 0;
  while (true) {
    const { data, error } = await buildQuery(from, from + PAGE_SIZE_POSTGREST - 1);
    if (error) throw error;
    if (!data || data.length === 0) break;
    result.push(...data);
    if (data.length < PAGE_SIZE_POSTGREST) break;
    from += PAGE_SIZE_POSTGREST;
  }
  return result;
}
